<div class="dialog-content-wrapper">
  <div class="sign-example-container">
    <div *ngIf="!imageLoaded" class="image-loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
    <img
      *ngIf="imageUrl"
      [src]="imageUrl"
      class="sign-example-image"
      (load)="onImageLoad()"
      [style.display]="imageLoaded ? 'block' : 'none'"
    />
  </div>
  <div class="content-container">
    <div class="strong">Aanvraag nieuwe voorraadborden</div>
    <div>
      <div class="strong">Kies de gewenste aantallen</div>
      <div class="smaller-text">(Eén V-bord bestaat uit 2 enkele borden)</div>
    </div>
    <div class="flex-col">
      <mat-checkbox
        *ngFor="let option of orderStockOptions"
        [(ngModel)]="option.selected"
        (change)="optionSelectedChange(option.amount, $event.checked)"
        [disabled]="!option.enabled"
      >
        <div>
          <span class="strong">{{ option.amount }}</span> borden
          <span *ngIf="sign.displayPrices && option.pricePerUnit > 0"> - </span>
          <span
            class="strong"
            *ngIf="sign.displayPrices && option.pricePerUnit > 0"
            >{{
              calculateTotalPriceForOption(option) | number : '1.2-2'
            }}&euro;/stuk</span
          >
        </div>
        <div
          *ngIf="option.amount === 10 && option.selected"
          class="red-warning"
        >
          <span class="red-exclamation">&#10071;</span> Digitaal drukwerk,
          hergebruik van borden niet gegarandeerd
        </div>
      </mat-checkbox>
      <mat-checkbox
        [(ngModel)]="otherAmountSelected"
        (change)="otherOptionSelectedChange($event.checked)"
        [disabled]="!otherAmountEnabled"
      >
        <div>
          <input
            matInput
            type="number"
            class="other-stock-amount"
            [(ngModel)]="orderAmount"
            [disabled]="!otherAmountEnabled"
          />&nbsp;borden
        </div>
      </mat-checkbox>
    </div>
    <div class="comment-section">
      <div class="strong">Opmerkingen</div>
      <textarea
        matInput
        [(ngModel)]="message"
        placeholder="Voeg hier eventuele opmerkingen toe..."
        rows="3"
        class="comment-textarea"
      ></textarea>
    </div>
    <div class="submit-wrapper">
      <ng-container *ngIf="submitting">
        <div class="spinner-container">
          <mat-spinner color="primary" diameter="75"></mat-spinner>
        </div>
      </ng-container>
      <ng-container *ngIf="!submitting">
        <button
          mat-button
          class="order-stock-button full-width"
          (click)="submit()"
        >
          {{ otherAmountSelected ? ' + Offerte aanvragen ' : 'Bestellen' }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
<div class="warning-container" *ngIf="isDirectOrder()">
  <div class="warning-text">
    Let op, dit is een onmiddelijke bestelling van nieuwe voorraadborden volgens
    de getoonde prijs.
    <br />
    We sturen hiervoor geen aparte offerte meer.
  </div>
</div>
